<!--
  EditorSwitchRow.vue

  One label-left / switch-right row for the store-editor Pricing page. Every
  toggle on that page (Accept Shopper Payments, Collect Sales Tax, Shipping
  cost, Create Fundraiser, Shopper Coupons, ...) renders through this row so
  they share ONE right edge.

  Why a shared row (Jake, 2026-10-22, after #4681): each card used to lay its
  switch out its own way. Some used a 1/12 grid column (56px) that was
  narrower than the switch itself, so the switch spilled out of it; the
  sub-option rows sat in a nested row/col/drawer chain with different insets;
  and the Payments & Pricing v-card clips overflow, which cut off the thumb
  Vuetify hangs a few px past the track. A flex row with a non-shrinking
  control, no grid column, and the card allowed to overflow fixes all three in
  one place.

  Slots
    label    the row label (default: the `label` prop)
    hint     optional helper text under the label
    default  the control (a compact, hide-details v-switch, usually inside a
             v-tooltip activator)

  Rows nested inside an inset container (the payment-method drawer) set
  --editor-switch-row-bleed on that container so their switch still lands on
  the page's one right edge; the row itself stays container-agnostic.
-->
<template>
  <div class="editor-switch-row">
    <div class="editor-switch-row__text">
      <div class="md-body-no-spacing editor-switch-row__label">
        <slot name="label">{{ label }}</slot>
      </div>
      <slot name="hint" />
    </div>
    <div class="editor-switch-row__control">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "EditorSwitchRow",
  props: {
    label: { type: String, default: "" },
  },
};
</script>

<style scoped>
.editor-switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 40px;
  padding: 4px 0;
}

.editor-switch-row__text {
  flex: 1 1 auto;
  min-width: 0;
}

/* The control never shrinks (a switch squeezed below its own width is what
   cropped the thumb) and never wraps under the label. */
.editor-switch-row__control {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-right: var(--editor-switch-row-bleed, 0px);
}
</style>
